var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('brace',{staticClass:"kbet-editor",staticStyle:{"height":"90vh"},attrs:{"mode":'json'},on:{"setHandler":function (h) {
						_vm.editorHandler = h;
					}}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }